import React from "react";
import { Button, Input } from "../components/Form";
import { HiOutlineCheckCircle } from "react-icons/hi";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { resetPassword } from "../redux/features/authSlice";
import toast from "react-hot-toast";

// Llega desde el link del mail: /reset-password?token=...&email=...
function ResetPassword() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const email = searchParams.get("email");
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    if (!token || !email) {
      toast.error("El enlace no es válido. Pedí uno nuevo desde 'Olvidé mi contraseña'.");
      return;
    }
    const res = await dispatch(
      resetPassword({
        token,
        email,
        password: data.password,
        password_confirmation: data.password_confirmation,
      })
    );
    if (resetPassword.fulfilled.match(res)) {
      toast.success("Contraseña actualizada. Ya podés iniciar sesión.");
      navigate("/login");
    } else {
      toast.error(res.payload || "No se pudo restablecer la contraseña.");
    }
  };

  return (
    <div className="w-full h-screen flex-colo bg-dry">
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="w-full sm:w-2/5 p-8 rounded-2xl mx-auto bg-white flex-colo"
      >
        <img
          src="/images/logomenu.png"
          alt="logo"
          className="w-48 h-16 object-contain"
        />
        {!token || !email ? (
          <div className="mt-6 text-center flex flex-col gap-4">
            <p className="text-sm text-red-500">
              Este enlace no es válido o le faltan datos.
            </p>
            <Link to="/forgot-password" className="text-sm text-subMain">
              Pedir un enlace nuevo
            </Link>
          </div>
        ) : (
          <div className="flex flex-col gap-4 w-full mb-6 mt-6">
            <Input
              label="Nueva contraseña"
              type="password"
              color={true}
              placeholder="*********"
              register={register("password", {
                required: "La contraseña es obligatoria.",
                minLength: { value: 8, message: "Mínimo 8 caracteres." },
              })}
              error={errors.password}
            />
            <Input
              label="Repetir contraseña"
              type="password"
              color={true}
              placeholder="*********"
              register={register("password_confirmation", {
                required: "Repetí la contraseña.",
                validate: (v) => v === watch("password") || "No coincide con la contraseña.",
              })}
              error={errors.password_confirmation}
            />
            <Button
              label="Restablecer contraseña"
              Icon={HiOutlineCheckCircle}
              onClick={handleSubmit(onSubmit)}
            />
          </div>
        )}
      </form>
    </div>
  );
}

export default ResetPassword;
